import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ACCOUNTS_ACCOUNT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/accounts',
        iconClass: 'fas fa-address-card',
        name: '::Menu:Accounts',
        order: 105,
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.Accounts',
      },
    ]);
  };
}
